export class VIDEO_LOCATIONS {
  static readonly YOUTUBE = 'YouTube';
  static readonly YOUTUBE_PLAYLIST = 'YouTube Playlist';
  static readonly VIMEO = 'Vimeo';
  static readonly CONTENTSTACK = 'Contentstack';
}
